import React from 'react';
import { LegalLayout } from '@/components/LegalLayout';

export default function PrivacyPage() {
  return <LegalLayout ns="privacy" seo="privacy" testId="privacy-page" />;
}
